import UnsereMission from "./slides/UnsereMission";
import UnsereMissionAntwort from "./slides/UnsereMissionAntwort";

export default function Mission() {
  return [
    <UnsereMission key="unsere-mission" />,
    <UnsereMissionAntwort key="unsere-mission-antwort" />,
  ];
}
